export class ReplyNotificationDto {

    notificationId: number;
    subject: string;
    text: string;

}
